import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_dashboard/lender/")({
  beforeLoad: () => {
    throw redirect({ to: "/lender/home" })
  },
})
